import * as React from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Grid, GridColumn as Column, GridCell, GridSortChangeEvent } from '@progress/kendo-react-grid';
import { SortDescriptor, orderBy } from '@progress/kendo-data-query';
import { fetchApi } from '../../services/api';
import { StreetAddressViewModel } from '../StreetAddress';
import LoadingPanel from '../LoadingPanel';
import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
const DocumentTitle = require('react-document-title');

type Props = RouteComponentProps<{ }>;

type State = {
    sort: SortDescriptor[];
    Accounts: AccountData[];
    activeFilter?: boolean;
    isLoading: boolean;
}

export interface AccountData {
    AccountID: number;
    Active: boolean;
    BillingName: string;
    BillingEmail: string;
    BillingAddress: StreetAddressViewModel;
}

class BillingNameCell extends GridCell {
    render() {
        return (
            <td>
                <Link style={{ color: '#007bff' }} to={ `/accounts/${ this.props.dataItem.AccountID }` }>
                    {this.props.dataItem.BillingName}
                </Link>
            </td>
        );
    }
}

class ActiveCell extends GridCell {
    render() {
        return (
            <td>{this.props.dataItem.Active ? "Active" : "Deactivated"}</td>
        );
    }
}

class BillingAddressCell extends GridCell {
    render() {
        if (!this.props.dataItem.BillingAddress) {
            return <td />
        }
        return (
            <td>
                {(this.props.dataItem.BillingAddress.Line1 + ' ' + (this.props.dataItem.BillingAddress.Line2 || '')).trim()}, {this.props.dataItem.BillingAddress.City} {this.props.dataItem.BillingAddress.State} {this.props.dataItem.BillingAddress.Zip}
            </td>
        );
    }
}

class Accounts extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            Accounts: [],
            isLoading: false,
            activeFilter: true,
            sort: [{field: "BillingName", dir: "asc"}],
        };
        this.sortChange = this.sortChange.bind(this);
        this.onActiveFilterChange = this.onActiveFilterChange.bind(this);
    }

    public componentWillMount() {
        this.getAccounts();
    }

    public render() {
        const activeFilters = [{ ID: null, Name: 'All Accounts' }, { ID: true, Name: 'Active' }, { ID: false, Name: 'Deactivated' }]
        return <React.Fragment>
            <DocumentTitle title="Accounts" />
            <div className="row">
                <div className="col">
                    <h1>Accounts</h1>
                </div>
                <div className="col">
                    <Link
                        role="button"
                        className="btn btn-primary float-right"
                        to={ '/accounts/0' }
                    >
                        Add Account
                    </Link>
                    <DropDownList
                        className="float-right pr-2"
                        data={activeFilters}
                        textField={'Name'}
                        value={activeFilters.find(x => x.ID === this.state.activeFilter)}
                        onChange={this.onActiveFilterChange}
                    />
                </div>
            </div>
            {this.state.isLoading && <LoadingPanel />}
            <Grid data={this.state.Accounts}
                sortable={{
                    allowUnsort: true
                }}
                sort={this.state.sort}
                onSortChange={this.sortChange}
                pageable={{
                    buttonCount: 0,
                    info: true,
                    type: 'numeric',
                    pageSizes: false,
                    previousNext: false
                }}
                skip={0}
                take={this.state.Accounts.length}
                total={this.state.Accounts.length}
            >
                <Column field="BillingName" title="Name" cell={BillingNameCell} />
                <Column field="Active" title="Active" cell ={ActiveCell}/>
                <Column field="BillingEmail" title="Email" />
                <Column field="BillingAddress" sortable={false} title="Street Address" cell={BillingAddressCell} />
            </Grid>
            <br/>
        </React.Fragment>;
    }

    private onActiveFilterChange(e: DropDownListChangeEvent) {
        this.setState({ activeFilter: e.target.value.ID }, this.getAccounts);
    }

    private sortChange(event: GridSortChangeEvent) {
        this.setState({
            sort: event.sort,
            Accounts: orderBy(this.state.Accounts, event.sort)
        });
    }

    private getAccounts() {
        const data = {
            FacilityID: localStorage.getItem("FACILITY_ID"),
            Active: this.state.activeFilter
        }
        this.setState({ isLoading: true });
        fetchApi('api/Account/List', data, 'POST')
            .then((accounts: AccountData[]) => {
                this.setState({ Accounts: orderBy(accounts, this.state.sort), isLoading: false});
            });
    }
}

export default Accounts;
